// assets/jonbit-comparison.js

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', e => {
    // 1) Tab switching
    let tabBtn = e.target.closest('.comparison-tab-btn');
    if (tabBtn) {
      let section = tabBtn.closest('[id^="comparison-section-"]');
      let allBtns = section.querySelectorAll('.comparison-tab-btn');
      let allContents = section.querySelectorAll('.comparison-tab-content');

      allBtns.forEach(b => b.classList.remove('active'));
      tabBtn.classList.add('active');

      allContents.forEach(c => c.classList.remove('active'));
      let target = section.querySelector('#' + tabBtn.dataset.target);
      if (target) target.classList.add('active');
      return;
    }

    // 2) Feature expand/collapse
    let feature = e.target.closest('.feature-item');
    if (feature && feature.dataset.toggle) {
      let section = feature.closest('[id^="comparison-section-"]');
      let detail = section.querySelector('#' + feature.dataset.toggle);
      feature.classList.toggle('open');
      if (detail) detail.classList.toggle('active');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const comparisonForms = document.querySelectorAll('.comparison-product-form');

  comparisonForms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('.comparison-submit-btn');
      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'true');
        const spinner = submitBtn.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }

      // FormData aufbauen
      const formData = new FormData(form);

      // Be Yours 7.0.1 benötigt die Section Rendering API IDs
      const miniCartComponent = document.querySelector('mini-cart');
      if (miniCartComponent && typeof miniCartComponent.getSectionsToRender === 'function') {
        const sections = miniCartComponent.getSectionsToRender().map((s) => s.section);
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (response.ok) {
          const parsedState = await response.json();

          // Be Yours Cart Drawer rendern und öffnen
          if (miniCartComponent && typeof miniCartComponent.renderContents === 'function') {
            miniCartComponent.renderContents(parsedState);
          } else {
            // Fallback, falls das Web-Component nicht gefunden wird
            window.location.href = `${window.Shopify.routes.root}cart`;
          }
        } else {
          const errorData = await response.json();
          console.error('Shopify Cart Error:', errorData.description || errorData.message);
        }
      } catch (error) {
        console.error('Netzwerkfehler beim Hinzufügen zum Warenkorb:', error);
      } finally {
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          const spinner = submitBtn.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      }
    });
  });
});